import BaseAuthProvider from './BaseAuthProvider'
import AuthService from '../service'
import { AuthProviders } from '../constants/authProviders'

/**
 * Password Authentication Provider
 * Traditional email/password login
 */
export class PasswordAuthProvider extends BaseAuthProvider {
    getMethod() {
        return AuthProviders.PASSWORD
    }

    /**
     * Password login is controlled only by .env
     * No custom subdomain or backend restrictions
     */
    isEnabled(context) {
        return context.envProviders.includes(this.getMethod())
    }

    /**
     * Authenticate with email and password
     * @param {Object} credentials
     * @param {string} credentials.email - User email
     * @param {string} credentials.password - User password
     * @returns {Promise<{token: string, tokenType: string}>}
     */
    async authenticate({ email, password }) {
        const response = await AuthService.getAuthToken(email, password)

        // Return token plus any additional metadata from backend
        return {
            token: response.data.token,
            tokenType: 'Token',
            ...response.data  // Include metadata if backend adds any in future
        }
    }

    /**
     * Get alternative providers for password login
     * Email token passwordless is the preferred alternative
     * Social providers are shown separately, not as alternatives
     */
    getAlternatives(enabledProviders) {
        const alternatives = []

        if (enabledProviders.includes(AuthProviders.EMAIL_TOKEN)) {
            alternatives.push(AuthProviders.EMAIL_TOKEN)
        }

        return alternatives
    }
}

export default PasswordAuthProvider
